// extracted by mini-css-extract-plugin
export default {"grid":"Main_grid__gWNJn"};